// When there's no page to show: an address TUNE Analytics doesn't have, in the frame (the admin dashboard's, under
// /admin); or a page that broke, on its own, as TUNE's words rather than the browser's, with a way on.
import { Page } from '../../shell/Page';
import { AuthFrame } from '../../shell/AuthFrame';
import { Button, ButtonLink, EmptyState } from '../../ui';
import { CompassIcon } from '../../ui/icons';
import s from './Errors.module.css';

export function NotFound({ admin = false }: { admin?: boolean }) {
  return (
    <Page title="There's no such page">
      <EmptyState
        icon={<CompassIcon size={56} />}
        title={admin ? "This address isn't one of the admin dashboard's" : "This address isn't one of TUNE Analytics'"}
        action={
          admin ? (
            <ButtonLink to="/admin">Go to the overview</ButtonLink>
          ) : (
            <ButtonLink to="/">Go to TUNE Analytics</ButtonLink>
          )
        }
      >
        It may be mistyped, or the page has moved.
      </EmptyState>
    </Page>
  );
}

export function Broken() {
  return (
    <AuthFrame title="Something went wrong on this page" tab="Something went wrong">
      <div className={s.broken}>
        <p>Reload it to try again. If it keeps happening, tell TUNE what you were doing: contact@tunemfd.com.</p>
        <div className={s.actions}>
          <Button onClick={() => window.location.reload()}>Reload the page</Button>
          {/* A fresh start: the app may be what broke. */}
          <Button variant="gray" onClick={() => window.location.assign('/')}>
            Go to TUNE Analytics
          </Button>
        </div>
      </div>
    </AuthFrame>
  );
}
